import type { EventReminder } from 'models';
import { Modal, type ModalOptions } from 'ui';
import { EditReminderForm } from './edit-reminder-form';

export type EditReminderModalOptions = {
  event: EventReminder;
};

type P = {
  onCancel: () => void;
  onSuccess: () => void;
  options: ModalOptions<EditReminderModalOptions>;
};

const EditReminderModal = ({ onCancel, onSuccess, options }: P) => (
  <Modal isOpened={options.isOpened} onCancel={onCancel} title="Edit Reminder" width="large">
    {options.isOpened ? (
      <Modal.HugContent>
        <EditReminderForm event={options.event} onCancel={onCancel} onSuccess={onSuccess} />
      </Modal.HugContent>
    ) : null}
  </Modal>
);

export default EditReminderModal;
